var map = {
	"./de/group-logo.png": "TqEX",
	"./en/group-logo.png": "ZJSn",
	"./es/group-logo.png": "VNLt",
	"./fr/group-logo.png": "bkdy",
	"./ja/group-logo.png": "titI",
	"./ko/group-logo.png": "l9dP",
	"./pt/group-logo.png": "I0xS",
	"./ru/group-logo.png": "Jl0C",
	"./tc/group-logo.png": "Tv85",
	"./th/group-logo.png": "ekK6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "j12H";